module.exports = __webpack_public_path__ + "static/media/icon_map_b.9a2a8738.svg";